import { useEffect } from "react";
import { useParams } from "react-router";
import { getMeetingSummaryData } from "../../api/invitations";
import { LoadingSpinner } from "../../components/loading-spinners";
import {
  Box,
  Container,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import FlexBox from "../../components/layouts/Flexbox";
import PrintIcon from "@mui/icons-material/Print";
import "./style.css";
import { concatSelectedFromToTime } from "../../services/utils/date-and-time.utils";
import Logo from "../../components/Logo";
import { useMutationWithDispatch } from "../../hooks/useMutationWithDispatch";
import { APP_FONT_FAMILIES, APP_COLORS } from "../../enums";
import { SomethingWentWrong } from "../../components/form/errors";

export default function MeetingSummary() {
  const token = useParams().token;
  const {
    mutate: fetchSummary,
    data: summary,
    isPending: loading,
  } = useMutationWithDispatch(getMeetingSummaryData, {
    showErrorToast: true,
  });
  const meetingSummaryData = summary?.data;

  useEffect(() => {
    fetchSummary(token);
  }, []);

  if (loading) {
    return <LoadingSpinner loading={loading} />;
  }

  if (!meetingSummaryData || !token) {
    return (
      <Container>
        <FlexBox my={2} mb={5}>
          <Logo />
        </FlexBox>
        <SomethingWentWrong
          title="Invalid link"
          message="This invitation link is invalid or missing a token. Please use the link from your invitation email."
        />
      </Container>
    );
  }



  return (
    <Container>
      <FlexBox my={2} mb={5}>
        <Logo />
      </FlexBox>
      <FlexBox alignItems={"center"} justifyContent={"space-between"} mb={1}>
        <Box>
          <Typography color={"secondary"} variant="h4" mb={1}>
            Meeting Summary
            {meetingSummaryData?.title ? ` - ${meetingSummaryData?.title}` : ""}
          </Typography>
          <Typography variant="caption" color={"textSecondary"}>
            {meetingSummaryData?.selectedTimeSlot
              ? `${concatSelectedFromToTime(
                meetingSummaryData?.selectedTimeSlot
              )}`
              : ""}
          </Typography>
        </Box>
        <IconButton id="printPageButton" onClick={() => window.print()}>
          <PrintIcon fontSize="large" />
        </IconButton>
      </FlexBox>
      <Divider />
      <Box my={2}>
        {["Meeting Recap", "Next Steps"]?.map((key) => {
          return (
            <div key={`meeting-summary-${key}`}>
              <Typography fontWeight={"bold"}>{key}</Typography>
              <ul>
                {meetingSummaryData[key]?.map((item, index) => {
                  return (
                    <li key={index}>
                      <Typography fontSize={14} variant="caption">
                        {item}
                      </Typography>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
        <Stack gap={0}>
          <Typography
            variant="caption"
            fontFamily={APP_FONT_FAMILIES.ibmPlexMono}
            sx={{ color: APP_COLORS.textMuted2 }}
            my={3}
          >
            *These summary is generated by AI and can produce non accurate
            information occasionally, please practise caution while applying
            these summary.
          </Typography>
          <Typography
            variant="caption"
            fontFamily={APP_FONT_FAMILIES.ibmPlexMono}
            sx={{ color: APP_COLORS.textMuted2 }}
          >
            In case you need help from subject matter expert, please feel free
            to reach out to us at{" "}
            <Typography
              variant="caption"
              fontFamily={APP_FONT_FAMILIES.ibmPlexMono}
              sx={{ color: APP_COLORS.textMuted2, textDecoration: "underline" }}
              component={"a"}
              href="mailto:vicky.tuneva@cyberriskalliance.com"
            >
              vicky.tuneva@cyberriskalliance.com
            </Typography>
          </Typography>
        </Stack>
      </Box>
    </Container>
  );
}
